import { compose, flip, isEmpty, pickBy, replace, toLower, toUpper, trimStart } from 'lodash/fp';
import { SubmissionError } from 'redux-form';

import { extractError } from 'utils/gqlUtils';

// redux-form uses this property name to store errors which relates to whole form, ie. non-field errors
export const FORM_ERRORS = '_error';

/**
 * Sets form wide error.
 * @param {string} error
 * @return {{_error: string}}
 */
export const formErrorObject = (error) => ({ [FORM_ERRORS]: error });

/**
 * Gather from object all properties which name begins with "on"
 */
export const pickAllEventListeners = pickBy(flip(RegExp.prototype.test.bind(/^on[A-Z]/)));

/**
 * Derives SubmissionError from error responses
 * @param { originalError } originalError extracted from GQLErrorObject
 * @return {*}
 */
export function submissionErrorFromErrorResponse(originalError) {
	const { errorMessages, validationErrors } = extractError(originalError);

	const errors = {
		...(errorMessages && formErrorObject(errorMessages)),
		...validationErrors,
	};

	return isEmpty(errors) ? null : new SubmissionError(errors);
}

export function isSubmissionError(error) {
	return error && error.name === SubmissionError.name;
}

const RE_PHONE_NUMBER_DISALLOWED_CHARS = /[^\d+]/g;
export const parsePhoneNumber = (input) =>
	input && input.replace(RE_PHONE_NUMBER_DISALLOWED_CHARS, '');

export const parseDigits = replace(/\D+/g, ``);

export const parseName = compose(replace(/(^|\s)\S/g, toUpper), toLower, trimStart);

/**
 * Copied from React
 * @see https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/ReactDOMInput.js#L39
 * @param {object} props
 * @return {boolean}
 */
export function isControlled(props) {
	const usesChecked = props.type === 'checkbox' || props.type === 'radio';
	return usesChecked ? props.checked != null : props.value != null;
}
